const LESSON_PATH_MARKER = '/lessons/';

function sourceUnitIdFromActivityId(activityId) {
  if (!activityId || typeof activityId !== 'string') {
    return null;
  }
  const markerIndex = activityId.indexOf(LESSON_PATH_MARKER);
  if (markerIndex === -1) {
    return activityId;
  }
  const sourceUnitId = activityId.slice(0, markerIndex);
  return sourceUnitId || null;
}

function catalogUnitIdFromLesson(lesson) {
  if (!lesson) {
    return null;
  }
  const fromOriginalId = sourceUnitIdFromActivityId(lesson.originalId);
  if (fromOriginalId) {
    return fromOriginalId;
  }
  if (typeof lesson.activityId === 'string' && lesson.activityId.indexOf(LESSON_PATH_MARKER) !== -1) {
    return sourceUnitIdFromActivityId(lesson.activityId);
  }
  return null;
}

export function getUnitFileActivityIds(unit) {
  if (!unit || !unit.activityId) {
    return [];
  }
  if (unit.fromCatalog) {
    return [unit.activityId];
  }

  const sourceIds = [];
  const lessons = Array.isArray(unit.content) ? unit.content : [];
  lessons.forEach(lesson => {
    const sourceUnitId = catalogUnitIdFromLesson(lesson);
    if (!sourceUnitId || sourceUnitId === unit.activityId || sourceIds.includes(sourceUnitId)) {
      return;
    }
    sourceIds.push(sourceUnitId);
  });

  if (sourceIds.length === 0) {
    return [unit.activityId];
  }
  return sourceIds;
}
